import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { AiOutlineDownload } from "react-icons/ai";

const Main = () => {
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions();

    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  const updateDimensions = () => {
    const width = window.innerWidth;
    setWindowWidth(width);
  };

  const onButtonClick = () => {
    fetch("Gurjit_Singh_resume.pdf").then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "Gurjit_Singh_resume.pdf";
        alink.click();
      });
    });
  };
  let str = "<h3> Hi, my name is </h3>";
  let name =
    width > 1023
      ? "title text-[60px]  shine font-extrabold text-gray-100 p-0 m-0"
      : "title text-3xl mt-2 font-extrabold text-gray-100 p-0 m-0";
  let line =
    width > 1023
      ? "title text-[60px] overflow-hidden  shadow text-gray-400 font-extrabold p-0 m-0"
      : "title text-3xl text-gray-400 font-extrabold p-0 m-0";

  return (
    <div className="text-white h-[700px] mainbg pl-6 flex flex-col justify-center md:ml-[50px] ">
      <div>
        <motion.div
          initial={{ x: 0, y: 50, opacity: 0 }}
          animate={{ x: 0, y: 0, opacity: 1, transition: { duration: 1 } }}
          className="text-[#64ffda] ml-1"
        >
          {str}
        </motion.div>
        <motion.div
          initial={{ x: 0, y: 50, opacity: 0 }}
          animate={{ x: 0, y: 0, opacity: 1, transition: { duration: 1 } }}
          className={name}
        >
          Gurjit Singh.
        </motion.div>
        <motion.div
          initial={{ x: -150, opacity: 0 }}
          animate={{ x: 0, y: 0, opacity: 1, transition: { duration: 1 } }}
          className={line}
        >
          I build things for the web.
        </motion.div>
        <motion.div
          initial={{ x: 0, y: 50, opacity: 0 }}
          animate={{ x: 0, y: 0, opacity: 1, transition: { duration: 1 } }}
          className="text-gray-300 md:text-md text-sm my-4"
        >
          <motion.span
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, y: 0, opacity: 1, transition: { duration: 2 } }}
          >
            {" "}
            I am a passionate and creative developer
            <span className="text-[#64ffda]">.</span>
          </motion.span>
          <br></br>
          <motion.span
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, y: 0, opacity: 1, transition: { duration: 2 } }}
          >
            {" "}
            I'm constantly exploring new technologies and techniques
          </motion.span>
          <br></br>
          <motion.span
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, y: 0, opacity: 1, transition: { duration: 2 } }}
          >
            {" "}
            to enhance my skills and deliver outstanding results
            <span className="text-[#64ffda]">.</span>
          </motion.span>
          <br></br>
          <motion.span
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, y: 0, opacity: 1, transition: { duration: 2 } }}
          >
            {" "}
            Let's create something amazing together
            <span className="text-[#64ffda]">!</span>
          </motion.span>
        </motion.div>
        <motion.button
          initial={{ x: 500, opacity: 0 }}
          animate={{ x: 0, y: 0, opacity: 1, transition: { duration: 1 } }}
          className="text-[#64ffda] font-extralight border border-[#64ffda]  mt-4 p-2 flex rounded-md"
        >
          <a href="https://gurjit-singh-resume.tiiny.site" className="flex">
            Check out my Resume!
            <div className="border-l-2 border-[#64ffda] block w-1 h-6 ml-2 mr-1"></div>
            <AiOutlineDownload className="text-2xl" />
          </a>
        </motion.button>
      </div>
    </div>
  );
};

export default Main;
